import {Injectable} from '@angular/core';



import {
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot
} from "@angular/router";
import {Subject} from "rxjs";
import {
  ClientQuestionService
} from "../../../../../swaggerServices";
import {IClientQuestion} from "./question/client-rules-question.component";

@Injectable()
export class ClientRulesQuestionsResolver  {

  question: any;
  $question: Subject<IClientQuestion> = new Subject<IClientQuestion>();

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private clientQuestionService: ClientQuestionService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const isNewQuestion = route.paramMap.get('id') === "new";
    const taxYr = Number(route.queryParams.taxYear);

    if (isNewQuestion) {
      const question: IClientQuestion = {
        clientCategoryId: null,
        clientHint: null,
        dataType: "string",
        default: null,
        dependantMandatoryParentId: null,
        dependantMandatoryParentValue: null,
        displayFieldType: "text",
        hidden: false,
        id: null,
        isCurrency: false,
        isPercentage: false,
        mandatory: true,
        filtering: false,
        max: null,
        maxLength: null,
        min: null,
        parentId: null,
        question: null,
        topLevel: false,
        valueFormat: null,
        year: taxYr,
        status: 0
      };
      this.question = question;
      setTimeout(() => this.$question.next(this.question))

    } else {
      const id = Number(route.paramMap.get('id'));
      return this.fetch(id);
    }

  }

  getQuestionsObs() {
    return this.$question;
  }

  private fetch(id: number) {
    return this.clientQuestionService.getClientQuestionWithDropdowns(id).subscribe(data => {
      this.question = data;
      this.$question.next(this.question);
      return data;
    });

  }

}
